import * as Yup from "yup";

import type { Currency } from "@krea/shared/types/common";

import { AmortizationMethodEnum } from "@/features/common/enums";

export const LenderMonthlyAmountValidation = (
  currency: Currency,
  formatWithCurrency: (value: number) => string,
) =>
  Yup.number()
    .transform((value) => (isNaN(value) ? null : value))
    .when("amortizationMethod", {
      is: (amortizationMethod: AmortizationMethodEnum) =>
        amortizationMethod === AmortizationMethodEnum.FIXED,
      then: (schema) =>
        schema
          .required("Monthly amount is required")
          .typeError("Monthly amount is required")
          .min(
            20,
            (schema) =>
              `Monthly amount (in ${currency}) needs to be greater than ${schema.min}`,
          )
          .max(
            50 * 1000 * 1000,
            (schema) =>
              `Monthly amount (in ${currency}) can't be greater than ${formatWithCurrency(schema.max)}`,
          ),
      otherwise: (schema) => schema.nullable(),
    });
